// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT EDIT.

import { primitiveColors as primitives } from './PrimitiveColors';
import type { ValidSemanticColors } from './ValidSemanticColors';

export const darkColorList: Record<ValidSemanticColors, string> = {
  actionDangerDefaultBackgroundDefault: 'rgba(247, 146, 166, 0.0000)',
  actionDangerDefaultBackgroundHover: 'rgba(247, 146, 166, 0.0800)',
  actionDangerDefaultBackgroundPress: 'rgba(247, 146, 166, 0.1600)',
  actionDangerDefaultBorderDefault: primitives.red500,
  actionDangerDefaultBorderHover: primitives.red400,
  actionDangerDefaultBorderPress: primitives.red300,
  actionDangerDefaultTextDefault: primitives.red500,
  actionDangerDefaultTextHover: primitives.red400,
  actionDangerDefaultTextPress: primitives.red300,
  actionDangerPrimaryBackgroundDefault: primitives.red500,
  actionDangerPrimaryBackgroundHover: primitives.red400,
  actionDangerPrimaryBackgroundPress: primitives.red300,
  actionDangerPrimaryText: primitives.grey800,
  actionDefaultBackgroundDefault: 'rgba(138, 202, 255, 0.0000)',
  actionDefaultBackgroundHover: 'rgba(138, 202, 255, 0.0800)',
  actionDefaultBackgroundPress: 'rgba(138, 202, 255, 0.1600)',
  actionDefaultBorderDefault: primitives.grey650,
  actionDefaultBorderFocus: primitives.blue400,
  actionDefaultBorderHover: primitives.blue400,
  actionDefaultBorderPress: primitives.blue300,
  actionDefaultIconDefault: primitives.grey350,
  actionDefaultIconHover: primitives.blue400,
  actionDefaultIconPress: primitives.blue300,
  actionDefaultTextDefault: primitives.grey100,
  actionDefaultTextHover: primitives.blue400,
  actionDefaultTextPress: primitives.blue300,
  actionDisabledBackground: primitives.grey650,
  actionDisabledBorder: primitives.grey600,
  actionDisabledText: primitives.grey500,
  actionIconBackgroundDefault: 'rgba(255, 255, 255, 0.0000)',
  actionIconBackgroundHover: 'rgba(255, 255, 255, 0.0800)',
  actionIconBackgroundPress: 'rgba(255, 255, 255, 0.1600)',
  actionIconIconDefault: primitives.grey350,
  actionIconIconHover: primitives.grey300,
  actionIconIconPress: primitives.grey200,
  actionLinkDefault: primitives.blue500,
  actionLinkHover: primitives.blue400,
  actionLinkPress: primitives.blue300,
  actionPrimaryBackgroundDefault: primitives.blue500,
  actionPrimaryBackgroundHover: primitives.blue400,
  actionPrimaryBackgroundPress: primitives.blue300,
  actionPrimaryIcon: primitives.grey800,
  actionPrimaryTextDefault: primitives.grey800,
  actionPrimaryTextHover: primitives.grey800,
  actionPrimaryTextPress: primitives.grey800,
  actionTertiaryBackgroundDefault: 'rgba(143, 205, 255, 0.0000)',
  actionTertiaryBackgroundHover: 'rgba(143, 205, 255, 0.0800)',
  actionTertiaryBackgroundPress: 'rgba(143, 205, 255, 0.1600)',
  actionTertiaryIconDefault: primitives.blue500,
  actionTertiaryIconHover: primitives.blue400,
  actionTertiaryIconPress: primitives.blue300,
  actionTertiaryTextDefault: primitives.blue500,
  actionTertiaryTextHover: primitives.blue400,
  actionTertiaryTextPress: primitives.blue300,
  backgroundDanger: 'rgba(200, 45, 76, 0.1600)',
  backgroundPrimary: primitives.grey800,
  backgroundSecondary: primitives.grey700,
  backgroundSuccess: 'rgba(39, 124, 67, 0.1600)',
  backgroundWarning: 'rgba(190, 80, 30, 0.1600)',
  border: primitives.grey650,
  borderAccessible: primitives.grey300,
  borderDanger: primitives.red500,
  borderWarning: primitives.yellow500,
  codeBackground: primitives.grey650,
  overlayOverlay: 'rgba(31, 38, 45, 0.7200)',
  progressFill: primitives.grey600,
  progressTrack: primitives.grey700,
  skeleton: 'rgba(144, 164, 181, 0.1600)',
  tableBackgroundSelectedDefault: 'rgba(189, 205, 219, 0.0800)',
  tableBackgroundSelectedHover: 'rgba(189, 205, 219, 0.1200)',
  tableBackgroundUnselectedDefault: primitives.grey800,
  tableBackgroundUnselectedHover: 'rgba(189, 205, 219, 0.0400)',
  tagBrown: 'rgba(166, 99, 12, 0.8600)',
  tagCharcoal: 'rgba(68, 83, 95, 0.8600)',
  tagCoral: 'rgba(200, 50, 67, 0.8600)',
  tagDefault: primitives.grey650,
  tagHover: 'rgba(138, 202, 255, 0.0800)',
  tagIconDefault: primitives.grey350,
  tagIconHover: primitives.grey350,
  tagIconPress: primitives.grey350,
  tagIndigo: 'rgba(67, 74, 147, 0.8600)',
  tagInverse: primitives.grey800,
  tagLemon: 'rgba(250, 203, 102, 0.8600)',
  tagLime: 'rgba(48, 134, 19, 0.8600)',
  tagPink: 'rgba(180, 80, 145, 0.8600)',
  tagPress: 'rgba(138, 202, 255, 0.1600)',
  tagPurple: 'rgba(138, 99, 191, 0.8600)',
  tagTeal: 'rgba(4, 134, 125, 0.8600)',
  tagText: primitives.grey100,
  tagTurquoise: 'rgba(19, 125, 174, 0.8600)',
  textPlaceholder: primitives.grey400,
  textPrimary: primitives.grey100,
  textSecondary: primitives.grey350,
  textValidationDanger: primitives.red500,
  textValidationSuccess: primitives.green500,
  textValidationWarning: primitives.yellow500,
  tooltipBackgroundTooltip: primitives.grey300,
};
